var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_482","data-name":"Group 482","transform":"translate(-5758.736 10314.264)"},[React.createElement("rect",{"id":"Rectangle_150","data-name":"Rectangle 150","width":"40","height":"6","transform":"translate(5762.979 -10314.264) rotate(45)","fill":"#fff","key":0}),React.createElement("rect",{"id":"Rectangle_151","data-name":"Rectangle 151","width":"40","height":"6","transform":"translate(5758.736 -10285.979) rotate(-45)","fill":"#fff","key":1})]));
}

Close.defaultProps = {"width":"32.527","height":"32.527","viewBox":"0 0 32.527 32.527"};

module.exports = Close;

Close.default = Close;
